var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftCardBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 43,
    viewBox: "0 0 119 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.17857 23.6339V41.0446L1 36.9821V18.9911L17.192 1H79.3482L83.0045 5.0625H118V7.96429H19.2813L5.17857 23.6339Z",
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 1.16071
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftCardBorder);
export default __webpack_public_path__ + "static/media/left-card-border.ccb112c258f99c499a8b22fe00baacb3.svg";
export { ForwardRef as ReactComponent };